import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=00a6c972"
import script from "./PageForm.vue?vue&type=script&lang=ts"
export * from "./PageForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports